import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface RoleRequestData {
  roleId: string;
  roleName: string;
  jdTitle: string;
  comments: string;
  roleTitle: string;
  numberOfPositions: number;
  duuration: number;
  skillLevel: string;
}
const initialState: RoleRequestData[] = [];
const formDataSlice = createSlice({
  name: 'roleRequestData',
  initialState,
  reducers: {
    setRoleRequestData: (state, action) => {
      state.push(action.payload);
    },
    deleteRoleRequestData: (state, action: PayloadAction<string>) => {
      return state.filter((item) => item.roleId !== action.payload);
    },
    clearRoleRequestData: () => {
      return [];
    }
  }
});

export const {
  setRoleRequestData,
  clearRoleRequestData,
  deleteRoleRequestData
} = formDataSlice.actions;
export default formDataSlice.reducer;
